module.exports = __webpack_public_path__ + "static/media/pisos.8f55a8e7.svg";